import React, { useEffect, useMemo, useState } from 'react';
import { fetchPayrollData, savePayrollData, setPayrollActive } from '../../services/adminService';
import { getUserDisplayName } from '../../services/authService';

const TIPOS = [
  { id: 'honorarios_profesionales', label: 'Honorarios profesionales' },
  { id: 'hora_definido', label: 'Contrato por hora definido' },
  { id: 'hora_indefinido', label: 'Contrato por hora indefinido' },
];

const CONTRATOS = {
  honorarios_profesionales: [
    { id: 'administrativo', label: 'Administrativo' },
    { id: 'honorarios_profesionales', label: 'Honorarios profesionales' },
    { id: 'operativo', label: 'Operativo' },
  ],
  hora_definido: [
    { id: 'administrativo', label: 'Administrativo' },
    { id: 'operativo', label: 'Operativo' },
  ],
  hora_indefinido: [
    { id: 'administrativo', label: 'Administrativo' },
    { id: 'operativo', label: 'Operativo' },
  ],
};

const IMPRESION = [
  { id: 'opcion_1', label: 'Opción 1 (15 y 30)' },
  { id: 'opcion_2', label: 'Opción 2 (5 y 20)' },
  { id: 'opcion_3', label: 'Opción 3 (10 y 25)' },
];

const formularioDesde = (nomina) => ({
  tipo_nomina: nomina.tipo_nomina,
  tipo_contrato: nomina.tipo_contrato,
  fecha_ingreso: nomina.fecha_ingreso || '',
  fecha_egreso: nomina.fecha_egreso || '',
  activar_decimo: nomina.activar_decimo || '',
  salario_base: nomina.salario_base != null ? String(nomina.salario_base) : '',
  horas_diarias: nomina.horas_diarias != null ? String(nomina.horas_diarias) : '',
  prima_produccion: nomina.prima_produccion != null ? String(nomina.prima_produccion) : '',
  dias_semanal: nomina.dias_semanal != null ? String(nomina.dias_semanal) : '',
  deduccion_seguro_social: Boolean(nomina.deduccion_seguro_social),
  deduccion_sso_xiii: Boolean(nomina.deduccion_sso_xiii),
  deduccion_seguro_educativo: Boolean(nomina.deduccion_seguro_educativo),
  porcentaje_seguro_social: nomina.deduccion_seguro_social ? String(nomina.porcentaje_seguro_social || '') : '',
  porcentaje_sso_xiii: nomina.deduccion_sso_xiii ? String(nomina.porcentaje_sso_xiii || '') : '',
  porcentaje_seguro_educativo: nomina.deduccion_seguro_educativo ? String(nomina.porcentaje_seguro_educativo || '') : '',
  calcula_islr: Boolean(nomina.calcula_islr),
  calcula_antiguedad: Boolean(nomina.calcula_antiguedad),
  opcion_impresion: nomina.opcion_impresion || '',
});

const formularioVacio = () => ({
  tipo_nomina: '',
  tipo_contrato: '',
  fecha_ingreso: '',
  fecha_egreso: '',
  activar_decimo: '',
  salario_base: '',
  horas_diarias: '',
  prima_produccion: '',
  dias_semanal: '',
  deduccion_seguro_social: false,
  deduccion_sso_xiii: false,
  deduccion_seguro_educativo: false,
  porcentaje_seguro_social: '',
  porcentaje_sso_xiii: '',
  porcentaje_seguro_educativo: '',
  calcula_islr: false,
  calcula_antiguedad: false,
  opcion_impresion: '',
});

const numero = (valor) => {
  const texto = String(valor || '').replace(',', '.').trim();
  const cantidad = parseFloat(texto);

  return Number.isFinite(cantidad) ? cantidad : 0;
};

const dinero = (valor) => numero(valor).toFixed(2);

const calcular = (salario, horas, prima) => {
  const base = numero(salario);
  const horasDia = numero(horas);
  const produccion = numero(prima);
  const porHora = horasDia > 0 ? base / (26 * horasDia) : 0;
  const primaHora = horasDia > 0 ? produccion / (26 * horasDia) : 0;

  return {
    hora: porHora,
    dia: porHora * horasDia,
    quincena: base / 2,
    primaHora,
    primaDia: primaHora * horasDia,
    primaQuincena: produccion / 2,
  };
};

const DEDUCCIONES = [
  { marca: 'deduccion_seguro_social', monto: 'porcentaje_seguro_social', label: 'S. Social' },
  { marca: 'deduccion_sso_xiii', monto: 'porcentaje_sso_xiii', label: 'SSO XIII mes' },
  { marca: 'deduccion_seguro_educativo', monto: 'porcentaje_seguro_educativo', label: 'Seguro educativo' },
];

const contratosDe = (tipo) => CONTRATOS[tipo] || [];

const etiqueta = (lista, id) => {
  const item = lista.find((opcion) => opcion.id === id);

  return item ? item.label : id;
};

const NominaDatosAdministrativos = ({ usuario, sessionId, onSalir }) => {
  const [statusAdm, setStatusAdm] = useState('activo');
  const [personalFijo, setPersonalFijo] = useState(false);
  const [nominas, setNominas] = useState([]);
  const [activas, setActivas] = useState(0);
  const [form, setForm] = useState(formularioVacio);
  const [vista, setVista] = useState('form');
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  const aplicarDatos = (datos, preferida) => {
    const lista = datos.nominas || [];
    const coincidente = preferida
      ? lista.find((item) => item.tipo_nomina === preferida.tipo_nomina && item.tipo_contrato === preferida.tipo_contrato)
      : null;
    const elegida = coincidente || lista.find((item) => !item.desactivada) || lista[0] || null;

    setStatusAdm(datos.status_adm || 'activo');
    setPersonalFijo(Boolean(datos.personal_fijo));
    setNominas(lista);
    setActivas(typeof datos.activas === 'number' ? datos.activas : 0);

    if (elegida) {
      setForm(formularioDesde(elegida));
    }
  };

  useEffect(() => {
    let vigente = true;

    setCargando(true);
    setError('');
    setAviso('');
    setVista('form');
    setForm(formularioVacio());

    fetchPayrollData(sessionId, usuario.id)
      .then((datos) => {
        if (vigente) {
          aplicarDatos(datos);
        }
      })
      .catch((requestError) => {
        if (vigente) {
          setError(requestError.message || 'No se pudieron cargar los datos administrativos.');
        }
      })
      .finally(() => {
        if (vigente) {
          setCargando(false);
        }
      });

    return () => {
      vigente = false;
    };
  }, [sessionId, usuario.id]);

  const contratos = CONTRATOS[form.tipo_nomina] || [];
  const calculo = useMemo(
    () => calcular(form.salario_base, form.horas_diarias, form.prima_produccion),
    [form.salario_base, form.horas_diarias, form.prima_produccion]
  );

  const cambiar = (campo) => (event) => {
    const valor = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    setForm((actual) => {
      const siguiente = { ...actual, [campo]: valor };

      if (campo === 'tipo_nomina') {
        const permitidos = CONTRATOS[valor] || [];

        if (!permitidos.some((item) => item.id === actual.tipo_contrato)) {
          siguiente.tipo_contrato = '';
        }
      }

      const deduccion = DEDUCCIONES.find((item) => item.marca === campo);

      if (deduccion && valor === false) {
        siguiente[deduccion.monto] = '';
      }

      return siguiente;
    });
    setAviso('');
    setError('');
  };

  const cargarNomina = (nomina) => {
    setForm(formularioDesde(nomina));
    setVista('form');
    setAviso('');
    setError('');
  };

  const guardar = () => {
    if (!form.tipo_nomina || !form.tipo_contrato) {
      setError('Selecciona el tipo de nómina y el tipo de contrato.');
      return;
    }

    const sinPorcentaje = DEDUCCIONES.some((item) => form[item.marca] && String(form[item.monto]).trim() === '');

    if (sinPorcentaje) {
      setError('Indica el porcentaje de cada deducción marcada.');
      return;
    }

    setGuardando(true);
    setError('');
    setAviso('');

    savePayrollData(sessionId, usuario.id, {
      status_adm: statusAdm,
      ...form,
      opcion_impresion: personalFijo ? form.opcion_impresion : '',
    })
      .then((datos) => {
        aplicarDatos(datos, {
          tipo_nomina: form.tipo_nomina,
          tipo_contrato: form.tipo_contrato,
        });
        setAviso('Datos administrativos guardados.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudieron guardar los datos.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  const cambiarEstado = (nomina) => {
    setError('');
    setAviso('');

    setPayrollActive(sessionId, usuario.id, nomina.id, !nomina.desactivada)
      .then((datos) => {
        aplicarDatos(datos);
        setAviso(nomina.desactivada ? 'Nómina activada.' : 'Nómina desactivada.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo actualizar la nómina.');
      });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-datos-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Datos administrativos de {getUserDisplayName(usuario)}</h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
      {error ? (
        <div className="admin-alert admin-alert--error" role="alert">
          {error}
        </div>
      ) : null}
      {aviso ? (
        <div className="admin-alert admin-alert--success" role="status">
          {aviso}
        </div>
      ) : null}
      {cargando ? <p className="admin-muted">Cargando datos…</p> : null}

      {!cargando && vista === 'lista' ? (
        <>
          <p className="admin-muted">Nóminas activas: {activas}</p>
          {nominas.length === 0 ? <p className="admin-muted">Todavía no hay nóminas creadas.</p> : null}
          {nominas.length > 0 ? (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Tipo de nómina</th>
                    <th>Tipo de contrato</th>
                    <th>Desactivada</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {nominas.map((nomina) => (
                    <tr key={nomina.id} className="config-monto-fila" onClick={() => cargarNomina(nomina)}>
                      <td>{etiqueta(TIPOS, nomina.tipo_nomina)}</td>
                      <td>{etiqueta(contratosDe(nomina.tipo_nomina), nomina.tipo_contrato)}</td>
                      <td>{nomina.desactivada ? 'SI' : ''}</td>
                      <td>
                        <button
                          type="button"
                          className="admin-btn admin-btn--secondary"
                          onClick={(event) => {
                            event.stopPropagation();
                            cambiarEstado(nomina);
                          }}
                        >
                          {nomina.desactivada ? 'Activar' : 'Desactivar'}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
          <div className="admin-pre-actions">
            <button type="button" className="admin-btn admin-btn--secondary" onClick={() => setVista('form')}>
              Volver
            </button>
            <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
              Salir
            </button>
          </div>
        </>
      ) : null}

      {!cargando && vista === 'form' ? (
        <>
          <div className="config-montos-principal">
            <label className="admin-field">
              <span>Fecha de ingreso</span>
              <input type="date" value={form.fecha_ingreso} onChange={cambiar('fecha_ingreso')} />
            </label>
            <label className="admin-field">
              <span>Fecha de egreso</span>
              <input type="date" value={form.fecha_egreso} onChange={cambiar('fecha_egreso')} />
            </label>
            <label className="admin-field">
              <span>Tipo de nómina</span>
              <select value={form.tipo_nomina} onChange={cambiar('tipo_nomina')}>
                <option value="">Seleccione</option>
                {TIPOS.map((tipo) => (
                  <option key={tipo.id} value={tipo.id}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </label>
            <label className="admin-field">
              <span>Tipo de contrato</span>
              <select value={form.tipo_contrato} onChange={cambiar('tipo_contrato')} disabled={!form.tipo_nomina}>
                <option value="">Seleccione</option>
                {contratos.map((contrato) => (
                  <option key={contrato.id} value={contrato.id}>
                    {contrato.label}
                  </option>
                ))}
              </select>
            </label>
            <label className="admin-field">
              <span>Status Adm.</span>
              <select value={statusAdm} onChange={(event) => setStatusAdm(event.target.value)}>
                <option value="activo">Activo</option>
                <option value="suspendido">Suspendido</option>
                <option value="retirado">Retirado</option>
              </select>
            </label>
            <label className="admin-field">
              <span>Activar décimo</span>
              <select value={form.activar_decimo} onChange={cambiar('activar_decimo')}>
                <option value="">—Status décimo—</option>
                <option value="si">Sí</option>
                <option value="no">No</option>
              </select>
            </label>
          </div>

          <div className="nomina-datos-grid">
            <section className="nomina-datos-bloque">
              <h3>Configurar asignaciones</h3>
              <div className="admin-form-row">
                <label className="admin-field">
                  <span>Salario base</span>
                  <input value={form.salario_base} onChange={cambiar('salario_base')} inputMode="decimal" />
                </label>
                <label className="admin-field">
                  <span>Horas diarias</span>
                  <input value={form.horas_diarias} onChange={cambiar('horas_diarias')} inputMode="decimal" />
                </label>
                <label className="admin-field">
                  <span>Prima producción</span>
                  <input value={form.prima_produccion} onChange={cambiar('prima_produccion')} inputMode="decimal" />
                </label>
              </div>
              <div className="admin-form-row nomina-datos-calculo">
                <label className="admin-field">
                  <span>Días semanal</span>
                  <input value={form.dias_semanal} onChange={cambiar('dias_semanal')} inputMode="decimal" />
                </label>
                <button type="button" className="admin-btn admin-btn--secondary" onClick={() => setAviso('Salario calculado.')}>
                  Calcular salario
                </button>
              </div>
              <div className="admin-form-row">
                <label className="admin-field">
                  <span>Salario/hora</span>
                  <input value={dinero(calculo.hora)} readOnly />
                  <span className="admin-muted">P/Producc. {dinero(calculo.primaHora)}</span>
                </label>
                <label className="admin-field">
                  <span>Salario/día</span>
                  <input value={dinero(calculo.dia)} readOnly />
                  <span className="admin-muted">P/Producc. {dinero(calculo.primaDia)}</span>
                </label>
                <label className="admin-field">
                  <span>Quincena</span>
                  <input value={dinero(calculo.quincena)} readOnly />
                  <span className="admin-muted">P/Producc. {dinero(calculo.primaQuincena)}</span>
                </label>
              </div>
            </section>

            <section className="nomina-datos-bloque">
              <h3>Configurar deducciones</h3>
              {DEDUCCIONES.map((item) => (
                <div key={item.marca} className="nomina-deduccion">
                  <label className="admin-checkbox">
                    <input type="checkbox" checked={form[item.marca]} onChange={cambiar(item.marca)} />
                    {item.label}
                  </label>
                  {form[item.marca] ? (
                    <label className="admin-field">
                      <span>Porcentaje</span>
                      <input
                        value={form[item.monto]}
                        inputMode="decimal"
                        placeholder="0.00"
                        onChange={cambiar(item.monto)}
                      />
                    </label>
                  ) : null}
                </div>
              ))}
              <label className="admin-checkbox">
                <input type="checkbox" checked={form.calcula_islr} onChange={cambiar('calcula_islr')} />
                Impuesto sobre la renta (15%)
              </label>
              <label className="admin-checkbox">
                <input type="checkbox" checked={form.calcula_antiguedad} onChange={cambiar('calcula_antiguedad')} />
                Antigüedad (1.923%)
              </label>
              {personalFijo ? (
                <label className="admin-field nomina-datos-impresion">
                  <span>Opción impresión en reportes</span>
                  <select value={form.opcion_impresion} onChange={cambiar('opcion_impresion')}>
                    <option value="">Seleccione</option>
                    {IMPRESION.map((opcion) => (
                      <option key={opcion.id} value={opcion.id}>
                        {opcion.label}
                      </option>
                    ))}
                  </select>
                </label>
              ) : (
                <p className="admin-muted">La opción de impresión aplica solo al personal fijo.</p>
              )}
            </section>
          </div>

          <div className="admin-pre-actions">
            <button type="button" className="admin-btn admin-btn--primary" onClick={guardar} disabled={guardando}>
              {guardando ? 'Guardando…' : 'Modificar empleado'}
            </button>
            <button type="button" className="admin-btn admin-btn--secondary" onClick={() => setVista('lista')}>
              Tipos de nóminas creadas
            </button>
            <button type="button" className="admin-btn admin-btn--secondary">
              Imprimir contrato
            </button>
            <button type="button" className="admin-btn admin-btn--secondary">
              Incapacidades e inasistencias
            </button>
            <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
              Salir
            </button>
          </div>
        </>
      ) : null}
      </div>
    </div>
  );
};

export default NominaDatosAdministrativos;
